<template>
    <div class="panel">
        <div class="panel_head fx fx-m_between fx-c_start">
            <el-form :inline="true" :model="form">
                <el-form-item label="关键词">
                    <el-input v-model="form.keywords" placeholder="关键词"></el-input>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select v-model="form.classId" clearable placeholder="请选择班级">
                        <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="日期">
                    <el-date-picker v-model="form.dateRange" type="daterange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>

        </div>
        <div class="panel_body">
            <el-tabs tab-position="left" v-model="activeTab" @tab-click="handleTabClick">
                <el-tab-pane label="作品统计" name="tab1">
                    <div style="width:100%;height:100%">
                        <el-table :data="tableData1" v-loading="loading1" element-loading-text="数据正在统计中,请稍后" stripe
                            style="width: 100%" height="550">
                            <el-table-column min-width="180" prop="studentName" label="学生姓名">
                            </el-table-column>
                            <el-table-column prop="scNum" min-width="180" label="Scratch作品数量">
                            </el-table-column>
                            <el-table-column prop="kidNum" min-width="180" label="Kid Scratch作品数量">
                            </el-table-column>
                            <el-table-column prop="pyNum" min-width="180" label="Python作品数量">
                            </el-table-column>
                            <el-table-column prop="cppNum" min-width="180" label="C++作品数量">
                            </el-table-column>
                            <el-table-column label="操作" min-width="180">
                                <template>
                                    <el-link type="primary" icon="el-icon-s-claim" @click="goWorks()">查看</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="panel_foot fx fx-m_end fx-c_center" style="">
                            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                                :current-page="pager1.currentPage" :page-size="pager1.pageSize"
                                :total="pager1.dataTotal" @current-change="pageChange1">
                            </el-pagination>
                        </div>

                    </div>
                </el-tab-pane>
                <el-tab-pane label=" 作业统计" name="tab2">
                    <div style="width:100%;height:100%">
                        <span style="color:red;">* 当前模块下,日期筛选只可查询任务完成数</span>
                        <el-table :data="tableData2" v-loading="loading2" element-loading-text="数据正在统计中,请稍后" stripe
                            style="width: 100%" height="550">
                            <el-table-column min-width="180" prop="className" label="班级">
                            </el-table-column>
                            <el-table-column min-width="180" prop="lessonName" label="课程名称">
                            </el-table-column>
                            <el-table-column min-width="180" prop="teacherName" label="上课教师">
                            </el-table-column>
                            <el-table-column min-width="180" prop="taskNum" label="总任务数">
                            </el-table-column>
                            <el-table-column min-width="180" prop="workNum" label="完成数">
                            </el-table-column>
                            <el-table-column min-width="180" prop="" label="完成率(完成数/总人数)">
                                <template slot-scope="scope">
                                    <div style="color:red;">
                                        {{ calculateWorkPerStudent(scope.row) }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" min-width="180">
                                <template slot-scope="scope">
                                    <el-link type="primary" icon="el-icon-s-claim"
                                        @click="goWorks2(scope.row)">查看</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="panel_foot fx fx-m_end fx-c_center" style="">
                            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                                :current-page="pager2.currentPage" :page-size="pager2.pageSize"
                                :total="pager2.dataTotal" @current-change="pageChange2">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="教师点评" name="tab3">
                    <div style="width:100%;height:100%">
                        <span style="color:red;">* 当前模块下,日期筛选只可查询点评数量</span>
                        <el-table :data="tableData3" v-loading="loading3" element-loading-text="数据正在统计中,请稍后" stripe
                            style="width: 100%" height="550">
                            <el-table-column min-width="180" prop="teacherName" label="教师名称">
                            </el-table-column>
                            <el-table-column min-width="180" prop="lessonNum" label="上课数量">
                            </el-table-column>
                            <el-table-column min-width="180" prop="taskNum" label="任务数量">
                            </el-table-column>
                            <el-table-column min-width="180" prop="evaluateNum" label="点评数量">
                            </el-table-column>

                            <el-table-column label="操作" min-width="180">
                                <template slot-scope="scope">
                                    <el-link type="primary" icon="el-icon-s-claim"
                                        @click="goWorks3(scope.row)">查看</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="panel_foot fx fx-m_end fx-c_center" style="">
                            <el-pagination :background="true" prev-text="上一页" next-text="下一页" layout="prev, pager, next"
                                :current-page="pager3.currentPage" :page-size="pager3.pageSize"
                                :total="pager3.dataTotal" @current-change="pageChange3">
                            </el-pagination>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<style scoped>

</style>


<script>
    import {
        mapMutations
    } from 'vuex';

    export default {
        components: {},
        props: [
            "attr"
        ],
        data() {
            return {
                activeTab: 'tab1', // 初始活动的标签页
                form: {
                    keywords: "",
                    classId: "",
                    startTime: '',
                    endTime: '',
                    dateRange: []
                },
                pager1: {
                    pageSize: 10,
                    dataTotal: 0,
                    currentPage: 1
                },
                loading1: false,
                tableData1: [],
                pager2: {
                    pageSize: 10,
                    dataTotal: 0,
                    currentPage: 1
                },
                loading2: false,
                tableData2: [],
                pager3: {
                    pageSize: 10,
                    dataTotal: 0,
                    currentPage: 1
                },
                loading3: false,
                tableData3: [],
                classList: [],
            }

        },

        watch: {
            "form": {
                handler: function(newValue) {
                    //判断当前的面板


                    if (this.activeTab == "tab1") {
                        this.pager1.currentPage = 1;
                        this.getStudentLearnList();
                    } else if (this.activeTab == "tab2") {
                        this.pager2.currentPage = 1;
                        this.getStudentWorkList();
                    } else if (this.activeTab == "tab3") {
                        this.pager3.currentPage = 1;
                        this.getTeacherList();
                    }
                },
                deep: true

            }
        },

        methods: {
            ...mapMutations(["openTab"]),
            calculateWorkPerStudent(row) {
                return row.studentCount > 0 ? (row.workNum / row.studentCount).toFixed(2) + "%" : '-';
            },
            goWorks() { //打开作品管理的选项卡
                this.openTab({
                    funcKey: "school_menu_work_manage",
                    title: "作品管理",
                    allowDuplicate: true,

                });
            },
            goWorks2(row) { //打开作品管理的选项卡
                this.openTab({
                    funcKey: "school_menu_student_learn_task_manage",
                    title: "任务统计",
                    allowDuplicate: true,
                    attr: {
                        item: row
                    }

                });
            },
            goWorks3(row) { //打开作品管理的选项卡
                    this.openTab({
                        funcKey: "school_menu_student_interest_statistics",
                        title: "学生兴趣统计",
                        allowDuplicate: true,
                        // attr: {
                        //     item: row
                        // }
                    });
            },
            handleTabClick(tab, event) {
                this.form = {
                    keywords: "",
                    classId: "",
                    startTime: '',
                    endTime: '',
                    dateRange: []
                }
            },

            getStudentLearnList() {

                if (this.form.dateRange == null) {
                    this.form.startTime = "";
                    this.form.endTime = "";
                } else {
                    if (this.form.dateRange.length == 2) {
                        this.form.startTime = this.form.dateRange[0];
                        this.form.endTime = this.form.dateRange[1];
                    }
                }
                let url = "";
                url = "/work/getLearnList";
                this.loading1 = true;
                this.$ajaxPost(url, {
                    form: this.form,
                    pager: {
                        ...this.pager1,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager1 = pager;
                    this.tableData1 = data.result;
                    this.loading1 = false;
                }, (error) => {
                    this.loading1 = false;
                    this.$showError("系统异常,请稍后重试!");
                })
            },
            getStudentWorkList() {

                if (this.form.dateRange == null) {
                    this.form.startTime = "";
                    this.form.endTime = "";
                } else {
                    if (this.form.dateRange.length == 2) {
                        this.form.startTime = this.form.dateRange[0];
                        this.form.endTime = this.form.dateRange[1];
                    }
                }
                let url = "";
                url = "/work/getWorkList";
                this.loading2 = true;
                this.$ajaxPost(url, {
                    form: this.form,
                    pager: {
                        ...this.pager2,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager2 = pager;
                    this.tableData2 = data.result;
                    this.loading2 = false;
                }, (error) => {
                    this.loading2 = false;
                    this.$showError("系统异常,请稍后重试!");
                })
            },
            getTeacherList() {

                if (this.form.dateRange == null) {
                    this.form.startTime = "";
                    this.form.endTime = "";
                } else {
                    if (this.form.dateRange.length == 2) {
                        this.form.startTime = this.form.dateRange[0];
                        this.form.endTime = this.form.dateRange[1];
                    }
                }
                let url = "";
                url = "/work/getEvaluateList";
                this.loading3 = true;
                this.$ajaxPost(url, {
                    form: this.form,
                    pager: {
                        ...this.pager3,
                        dataTotal: 0
                    }
                }, (data) => {
                    //分页不能带offset，否则会影响后台计算最新offset
                    let {
                        offset,
                        ...pager
                    } = data.pager;
                    this.pager3 = pager;
                    this.tableData3 = data.result;
                    this.loading3 = false;
                }, (error) => {
                    this.loading3 = false;
                    this.$showError("系统异常,请稍后重试!");
                })
            },
            pageChange1(page) {
                this.pager1.currentPage = page;
                this.getStudentLearnList();
            },
            pageChange2(page) {
                this.pager2.currentPage = page;
                this.getStudentWorkList();
            },
            pageChange3(page) {
                this.pager3.currentPage = page;
                 this.getTeacherList();
            },

            getClassList() {
                this.$ajaxPost("/class/list", {
                    form: {
                        enable: true,
                        hasEnable: true
                    }
                }, data => {
                    this.classList = data.result;
                })
            },

        },

        created() {
            this.getStudentLearnList();
            this.getClassList();
            this.getStudentWorkList();
            this.getTeacherList();
        }

    }
</script>
